import { useCallback } from 'react';
import { useNavigate, useParams, NavigateOptions } from 'react-router-dom';

import { buildTeamPath } from 'utils/teamFromUrl';

/**
 * A wrapper around `useNavigate` that automatically prepends the current
 * team key prefix (`/t/:teamKey`) to every path.
 *
 * Usage:
 *   const teamNavigate = useTeamNavigate();
 *   teamNavigate('/assets'); // → navigates to "/t/ACME/assets"
 */
export default function useTeamNavigate() {
  const navigate = useNavigate();
  const { teamKey } = useParams<{ teamKey?: string }>();

  return useCallback(
    (path: string, options?: NavigateOptions) => {
      const resolved = teamKey ? buildTeamPath(teamKey, path) : path;
      if (options) {
        navigate(resolved, options);
      } else {
        navigate(resolved);
      }
    },
    [navigate, teamKey],
  );
}
